import Filters from './Filters';
import exMap from '../Execution/ExecutionDetailMap';

const matchTables = query => {
    return query ? [...new Set([...query.matchAll(/(?:(?:from|join)(?:\s|\()+((?:\[*\w*\.\w*)+)(?:\s|\)|$))/gi)].map(x => x[1]))].sort() : []
}

const iconType = (page, type) => {
    return (((Filters[page] || {}).type || []).find(x => x.value === type) || {})
}

const sortResponse = (response, key, type) => {
    type === "alpha" && response.sort((a, b) => { return ((a[key] || "").toUpperCase() < (b[key] || "").toUpperCase()) ? -1 : 1 })
    type === "number" && response.sort((a, b) => { return b[key] - a[key] })
    return response
}

const updateCache = (dispatch, setFn, current, item, id = undefined) => {
    dispatch(setFn(sortResponse([
        ...current.data.filter(x => x.Id !== (id || item.Id)),
        !id && item
    ].filter(x => x !== false), "Name", "alpha")))
}

const makeJobPayload = (data, org, key, value, Name) => {
    return ({
        ...{
            Input: {
                ...{
                    org: org,
                    jobName: data.Name,
                    source: data.Input ? data.Input.source : {},
                    target: data.Input ? data.Input.target : {},
                    records: data.Input ? data.Input.records : []
                },
                ...{ [key]: value }
            }
        },
        ...Name
    })
}

const executionStepPayload = step => {
    const root = exMap[step.type] || {}
    let payload = root.key ? step[root.key][root.itemKey] : {}
    try {
        payload = JSON.parse(payload)
    } catch (e) {
        payload = { errorMessage: payload }
    }

    // calculate peripherals
    var row_count = 0
    payload.records && payload.records.map(x => row_count += (x ? x.row_count || 0 : 0))

    return {
        payload: payload,
        row_count: row_count,
        error: payload.errorMessage && payload.errorMessage
    }
}

export {
    matchTables,
    iconType,
    sortResponse,
    updateCache,
    makeJobPayload,
    executionStepPayload
};